// CUSTOM JS
// Simple toggle
let toggleBtn = document.querySelectorAll('.js-toggle-btn');

toggleBtn.forEach(function (btn) {
	btn.addEventListener('click', function (evt) {
		var isGroup = this?.parentElement?.parentElement?.classList.contains('nav-main__link-group') && !this?.parentElement?.parentElement?.classList.contains("nav-main__top-wrapper");

		// if not a group element click, then we can do all the other stuff for toggling
		if (!isGroup) {
			// toggle all other active elements
			var activeElements = document.getElementsByClassName('nav-main__link js-toggle-btn -active');

			for (var i = 0; i < activeElements.length; i++) {
				var currentElement = activeElements[i];
				if (currentElement !== evt.target) {
					// toggle these elements and their children
					currentElement.classList.remove('-active');
					if (currentElement?.nextElementSibling.classList.contains("-active")) {
						currentElement.nextElementSibling.classList.remove("-active");
					}
				}
			}
		}

		// toggle current
		this.classList.toggle('-active');

		this.querySelector('.js-toggle-target') ? btn.querySelector('.js-toggle-target').classList.toggle('-active') : '';
		this.parentElement.querySelector('.js-toggle-target') ? btn.parentElement.querySelector('.js-toggle-target').classList.toggle('-active') : '';
	})
});


window.onscroll = function () { headerSticky() };
window.onload = function() {headerSticky()}

function headerSticky() {
	let element = document.querySelector('nav.nav-main');
	if (window.pageYOffset > 50) {
		element.classList.add('scroll_nav');
	} else {
		element.classList.remove('scroll_nav');
	}
}


$(document).ready(function() {
   $('.feat-prod__slider').slick({
       infinite: false,
       slidesToShow: 4, 
       slidesToScroll: 1, 
       arrows: true, 
       responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
});